module.exports = __webpack_public_path__ + "img/user-men.b0b3cb96.png";